module.exports = __webpack_public_path__ + "img/full0-min.7c6ac7e6.png";